/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateLegacyProductMutationRequest,
  UpdateLegacyProductMutationResponse,
  UpdateLegacyProductPathParams,
  UpdateLegacyProduct400,
  UpdateLegacyProduct404,
} from '../types/UpdateLegacyProduct'

function getUpdateLegacyProductUrl({
  id,
}: {
  id: UpdateLegacyProductPathParams['id']
}) {
  const res = { method: 'PUT', url: `/api/v1/products/${id}/` as const }
  return res
}

/**
 * @summary Update a product (legacy endpoint)
 * {@link /api/v1/products/:id/}
 */
export async function updateLegacyProduct(
  { id }: { id: UpdateLegacyProductPathParams['id'] },
  data: UpdateLegacyProductMutationRequest,
  config: Partial<RequestConfig<UpdateLegacyProductMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateLegacyProductMutationResponse,
    ResponseErrorConfig<UpdateLegacyProduct400 | UpdateLegacyProduct404>,
    UpdateLegacyProductMutationRequest
  >({
    method: 'PUT',
    url: getUpdateLegacyProductUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
